import React from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import classnames from 'classnames';
import qs from 'qs';

import env from '../env';

export default function AdminSideNav (props) {
  const { navItems, user, className, location, ...extraProps } = props;

  return (
    <div className={classnames('px-2 py-3 admin-side-nav bg-dark text-white', className)} {...extraProps}>
      <ul className="h-100 nav nav-pills flex-column">
        {
          navItems.filter(_ => _.auth(user)).map(({ path, search = '', label, }) => {
            return (
              <li className="nav-item">
                <Link to={path + search} className={classnames('nav-link text-white', { active: location.pathname === path })}>
                  {label(props)}
                </Link>
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};
